import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { NavHashLink as NavLink } from "react-router-hash-link";
import styled from "styled-components";
import Social from "./social/social";

export default function ElevateAppBar(props) {
  return (
    <Router>
      <StyledNav>
        <NavLink smooth to="#top" activeClassName="selected">
          <svg
            title="Endeavor Films"
            className="logo"
            viewBox="0 0 110 110"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M45.214 28.147l10.023-14.16 9.555 14.16h7.49L55.236 3.09 37.72 28.147h7.495zm48.31 43.912l-6.164-9.458H64.256l-4.71-7.227H82.65l-9.266-14.218H36.616L27.35 55.374h23.103L45.745 62.6H22.64l-9.267 14.218h75.444l4.75 7.226H1.236l32.66-50.115h42.208l32.66 50.115h-7.36l-7.88-11.986zm-27.796 29.513c1.397 0 2.095-.528 2.095-1.585 0-.99-.68-1.484-2.039-1.484h-.525v3.069h.469zm1.367 1.108l3.026 4.121h-1.804l-2.792-3.958h-.266v3.958h-1.475v-9.67h1.728c1.292 0 2.225.24 2.799.72.633.535.95 1.24.95 2.117 0 .685-.2 1.274-.596 1.767-.397.493-.92.807-1.57.945zm13.257-1.853h-3.286v-2.324h3.406v-1.372h-4.881v9.67h1.475v-4.603h3.286v-1.371zm-20.968 3.732c.705-.71 1.057-1.574 1.057-2.593 0-1.031-.348-1.895-1.044-2.593-.692-.7-1.55-1.052-2.57-1.052-1.018 0-1.876.351-2.577 1.052-.7.694-1.051 1.55-1.051 2.568 0 1.07.363 1.948 1.089 2.637.722.69 1.555 1.034 2.5 1.034 1.026 0 1.891-.351 2.596-1.053zm1.038.959c-1.008.972-2.226 1.459-3.653 1.459-1.261 0-2.394-.432-3.399-1.297-1.106-.956-1.659-2.208-1.659-3.757 0-1.362.505-2.53 1.513-3.508 1.005-.977 2.212-1.465 3.621-1.465 1.393 0 2.588.493 3.584 1.477 1 .986 1.5 2.17 1.5 3.552 0 1.39-.502 2.57-1.507 3.539zm21.76 1.283h1.475v-9.67h-1.475v9.67zm24.728-1.19c-.582 0-1.025-.208-1.329-.626-.17-.217-.287-.61-.355-1.177l-1.494.325c.135.902.475 1.602 1.02 2.098.552.498 1.253.746 2.101.746.895 0 1.644-.293 2.248-.877.599-.58.899-1.315.899-2.204 0-.665-.184-1.225-.55-1.682-.368-.457-.949-.845-1.742-1.162l-.975-.395c-.71-.288-1.064-.667-1.064-1.14 0-.342.135-.626.405-.851.27-.23.61-.345 1.02-.345.334 0 .605.067.817.2.202.118.415.368.639.752l1.197-.701c-.634-1.086-1.514-1.628-2.64-1.628-.836 0-1.535.246-2.096.738-.562.489-.842 1.096-.842 1.823 0 1.077.668 1.896 2.007 2.455l.943.388c.245.105.456.214.633.33.177.114.322.237.434.368.112.132.194.276.247.433.053.157.079.329.079.517 0 .467-.152.854-.456 1.158-.304.305-.686.458-1.146.458zm-16.555-.181H87.48v-8.3h-1.475v9.67h4.35v-1.371zm6.47-1.51l-3.355-7.516-2.058 10.397h1.526l1.05-5.843 2.811 6.288 2.894-6.282.943 5.837h1.513L100.3 96.404l-3.475 7.516zm-91.431 1.51H1.475v-3.232H5.28v-1.371H1.475v-2.324h3.919v-1.372H0v9.67h5.394v-1.371zm18.955-3.464c0-1.06-.36-1.92-1.076-2.58-.646-.589-1.598-.883-2.856-.883h-.664v6.927h.664c.663 0 1.214-.069 1.653-.207a3.366 3.366 0 0 0 1.19-.695c.726-.656 1.089-1.51 1.089-2.562zm-.025-3.588c1.008.91 1.513 2.106 1.513 3.588 0 1.487-.526 2.69-1.577 3.608-.527.46-1.08.779-1.659.958-.54.18-1.306.27-2.298.27h-2.026v-9.67h2.052c.983 0 1.76.095 2.33.288a4.375 4.375 0 0 1 1.665.958zm15.84 4.703l-1.45-3.288-1.52 3.288h2.97zm-1.425-6.557l4.666 10.277H41.79l-1.025-2.348H36.58l-1.089 2.348h-1.589l4.837-10.277zm-24.279 7.328l-7.128-7.378V106.8h1.474v-6.77l7.129 7.359V97.131H14.46v6.72zm32.598-.02l-2.703-6.7H42.74l4.286 10.396 4.388-10.397h-1.615l-2.741 6.702zm-13.973 1.598h-3.918v-3.232h3.805v-1.371h-3.805v-2.324h3.918v-1.372h-5.394v9.67h5.394v-1.371z"
              fill="#FFF"
              fillRule="evenodd"
            />
          </svg>
        </NavLink>
        <NavLink smooth to="#top" activeClassName="selected">
          Mission
        </NavLink>
        <NavLink smooth to="#film" activeClassName="selected">
          Film
        </NavLink>
        <NavLink smooth to="#photography" activeClassName="selected">
          Photography
        </NavLink>
        <NavLink smooth to="#clients" activeClassName="selected">
          Clients
        </NavLink>
        <NavLink smooth to="#about" activeClassName="selected">
          About
        </NavLink>
        <NavLink smooth to="#contact" activeClassName="selected">
          Contact
        </NavLink>
        <SocialStyle>
          <Social />
        </SocialStyle>
      </StyledNav>
    </Router>
  );
}

const StyledNav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4.25em;
  line-height: 4.25em;
  text-align: center;
  z-index: 10;
  a {
    color: #fff;
    text-decoration: none;
    padding: 1em;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    &.selected:not(:first-of-type) {
      box-shadow: inset 0 -4px 0 -1px rgba(255, 255, 255, 1);
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 6.875em;
    z-index: 0;
    background: linear-gradient(
      hsl(0, 0%, 0%) 0%,
      hsla(0, 0%, 0%, 0.738) 19%,
      hsla(0, 0%, 0%, 0.541) 34%,
      hsla(0, 0%, 0%, 0.382) 47%,
      hsla(0, 0%, 0%, 0.278) 56.5%,
      hsla(0, 0%, 0%, 0.194) 65%,
      hsla(0, 0%, 0%, 0.126) 73%,
      hsla(0, 0%, 0%, 0.075) 80.2%,
      hsla(0, 0%, 0%, 0.042) 86.1%,
      hsla(0, 0%, 0%, 0.021) 91%,
      hsla(0, 0%, 0%, 0.008) 95.2%,
      hsla(0, 0%, 0%, 0.002) 98.2%,
      hsla(0, 0%, 0%, 0) 100%
    );
    opacity: 0.8;
  }
  .logo {
    height: 4.25em;
    z-index: 11;
    position: fixed;
    top: 0.825em;
    left: 1.625em;
    color: #fff;
  }
  @media (min-width: 220px) and (max-width: 560px) {
    .logo {
      left: calc(50% - 3.25em);
      transition: transform(-50%, 0);
      height: 6.875em;
    }
    padding-top: 5.25em;
    a {
      font-size: 0.75em;
      padding: 0 0.5em;
    }
    .MuiTypography-h2 {
      font-size: 1.625em;
    }
    h3 {
      font-size: 1em;
    }
    ::before {
      height: 16.875em;
    }
  }
`;

const SocialStyle = styled.div`
  position: fixed;
  top: 0.5em;
  right: 0.5em;
  svg {
    height: 1em;
    width: 1em;
  }
  @media (min-width: 220px) and (max-width: 560px) {
    display: none;
  }
`;
